import React, { useEffect, useState } from "react"
import PageMetaTags from "components/PageMetaTags"
import BreadcrumbTitle from "components/BreadcrumbTitle"
import { AddButton, RemoveButton } from "components/Buttons"
import Table from "components/Table"
import {
  getBusinessUnits,
  showDeleteModal,
  hideDeleteModal,
  deleteBusinessUnit,
  createBusinessUnit,
  updateBusinessUnit,
} from "store/actions"
import { connect } from "react-redux"
import { Col, Container, Row } from "reactstrap"
import ModalComponent from "components/Modals"
import businessUnitsListColumn from "containers/BusinessUnits/businessUnitsListColumns"
import BusinessUnitForm from "containers/BusinessUnits/businessUnitForm"

const BusinessUnits = props => {
  const defaultSorted = [
    {
      dataField: "name",
      order: "asc",
    },
  ]
  const [businessUnitModal, setBusinessUnitModal] = useState(false)
  const [defaultOrder, setDefaultOrder] = useState({
    o: defaultSorted[0].dataField,
    od: defaultSorted[0].order,
  })
  const [clickedBusinessUnit, setClickedBusinessUnit] = useState(null)

  const handlePageChange = page => {
    props.getBusinessUnits({ page: page, ...defaultOrder })
  }

  function handleSort(type, { sortField, sortOrder }) {
    props.getBusinessUnits({ page: 1, o: sortField, od: sortOrder })
    setDefaultOrder({ o: sortField, od: sortOrder })
  }

  const onRemoveBusinessUnit = item => {
    props.showDeleteModal()
    setClickedBusinessUnit(item)
  }

  const onCreateBusinessUnit = () => {
    setBusinessUnitModal(true)
    setClickedBusinessUnit(null)
  }

  const onEditBusinessUnit = item => {
    setBusinessUnitModal(true)
    setClickedBusinessUnit(item)
  }

  const actions = [
    {
      name: "Edit",
      onClick: onEditBusinessUnit,
      icon: "bx bx-show-alt",
      isAvailable: true,
    },
    {
      name: "Remove",
      onClick: onRemoveBusinessUnit,
      icon: "bx bx-trash",
      isAvailable: true,
    },
  ]

  const handleDeleteBusinessUnitSubmit = () => {
    props.deleteBusinessUnit({
      id: clickedBusinessUnit.id,
      callback: () => {
        props.getBusinessUnits({ page: 1, ...defaultOrder })
      },
    })
  }

  const handleSubmitBusinessUnit = values => {
    let data = {
      vendor_id: values.vendor_id,
      name: values.name,
    }
    if (values.id) {
      data.id = values.id
      props.updateBusinessUnit({
        values: data,
        callback: () => {
          props.getBusinessUnits({ page: 1, ...defaultOrder })
        },
      })
    } else {
      props.createBusinessUnit({
        values: data,
        callback: () => {
          props.getBusinessUnits({ page: 1, ...defaultOrder })
        },
      })
    }
    setBusinessUnitModal(false)
  }

  useEffect(() => {
    props.getBusinessUnits({ page: 1, ...defaultOrder })
  }, [])

  return (
    <React.Fragment>
      <div className="page-content">
        <PageMetaTags title={"Business Units list"} />
        <Container fluid>
          <BreadcrumbTitle
            title={"Business Units List"}
            breadcrumbItems={[
              { title: "Dashboard" },
              { title: "Business Units" },
            ]}
          />
          <Row>
            <Col xs={12} className={"mb-3 d-flex justify-content-end"}>
              <Col xs={6} lg={2} className="px-1">
                <AddButton
                  fullWidth={true}
                  content={"Add business unit"}
                  onClick={onCreateBusinessUnit}
                />
              </Col>
            </Col>
          </Row>

          <Row>
            <Col>
              <Table
                columns={businessUnitsListColumn()}
                onTableSort={handleSort}
                defaultSorted={defaultSorted}
                data={props.businessUnits}
                withCheckboxes={false}
                actions={actions}
                noTableDataMessage={"No business units to display"}
                loadingData={props.loading}
                paginationData={{
                  current_page: props.current_page,
                  last_page: props.last_page,
                  total_items: props.total_items,
                  items_per_page: props.items_per_page,
                  from: props.from,
                  to: props.to,
                }}
                onPageChange={handlePageChange}
              />
            </Col>
          </Row>
        </Container>

        <ModalComponent
          open={props.isDeleteModalOpen}
          onClose={props.hideDeleteModal}
          title={"Delete Business Unit"}
        >
          <p>Are you sure you want to delete this business unit?</p>
          <RemoveButton
            content={"Delete"}
            onClick={handleDeleteBusinessUnitSubmit}
            color={"dark"}
          />
          &nbsp;
          <RemoveButton content={"Cancel"} onClick={props.hideDeleteModal} />
          &nbsp;
        </ModalComponent>

        <ModalComponent
          open={businessUnitModal}
          onClose={() => setBusinessUnitModal(false)}
          title={
            clickedBusinessUnit
              ? "Update Business Unit: " + clickedBusinessUnit.name
              : "Create Business Unit"
          }
        >
          <BusinessUnitForm
            onSubmit={handleSubmitBusinessUnit}
            initialValues={
              clickedBusinessUnit && {
                ...clickedBusinessUnit,
                vendor_id: clickedBusinessUnit.vendor_id,
              }
            }
            loading={props.loading}
          />
        </ModalComponent>
      </div>
    </React.Fragment>
  )
}
const mapStateToProps = state => ({
  businessUnits: state.businessUnits.businessUnits,
  current_page: state.businessUnits.current_page,
  last_page: state.businessUnits.last_page,
  total_items: state.businessUnits.total_items,
  items_per_page: state.businessUnits.items_per_page,
  from: state.businessUnits.from,
  to: state.businessUnits.to,
  loading: state.businessUnits.loading,
  isDeleteModalOpen: state.businessUnits.isDeleteModalOpen,
  vendorId: state.Login.vendorId,
})

const mapDispatchToProps = dispatch => ({
  getBusinessUnits: values => dispatch(getBusinessUnits(values)),
  showDeleteModal: () => dispatch(showDeleteModal()),
  hideDeleteModal: () => dispatch(hideDeleteModal()),
  deleteBusinessUnit: values => dispatch(deleteBusinessUnit(values)),
  createBusinessUnit: businessUnit =>
    dispatch(createBusinessUnit(businessUnit)),
  updateBusinessUnit: businessUnit =>
    dispatch(updateBusinessUnit(businessUnit)),
})

export default connect(mapStateToProps, mapDispatchToProps)(BusinessUnits)
